export enum EXPORT_MODE {
    INPUT = "INPUT",
    EXPORT = "EXPORT",
    VIEW = "VIEW",
}